import { useContext, useMemo } from 'react';
import { useStoreContext } from '../FindInStoreContext';

export default function useAvailability(store = undefined) {
  const { availabilities, selectedStore, selectedSku } = useStoreContext();
  const sku = selectedSku;

  let storeId = store?.externalId || selectedStore?.externalId;

  return useMemo(() => {
    return availabilities[sku]?.[storeId] || null;
  }, [availabilities, sku, storeId]);
}
